import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Action } from 'redux';
import { ArtistLeadsSummaryResponse } from '@services/lead/types/api/artist-leads-summary-response';

export class GetLeads implements LoadingAction {
  readonly type = actions.GET_LEADS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor (public artistId: string) {}
}

export class GetLeadsSuccess implements LoadingAction {
  readonly type = actions.GET_LEADS_SUCCESS;
  readonly isLoading = false;
  readonly mainLoader = true;

  constructor (
    public summary: ArtistLeadsSummaryResponse,
  ) {}
}

export class GetLeadsError implements ErrorAction {
  readonly type = actions.GET_LEADS_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class ExportLeads implements Action {
  readonly type = actions.EXPORT_LEADS;

  constructor (public artistId: string) {}
}

export class ResetLeads implements Action {
  readonly type = actions.RESET_LEADS;
}

export type LeadsActions =
  | GetLeads
  | GetLeadsSuccess
  | GetLeadsError
  | ResetLeads
;